import classNames from "classnames";
import { ReactElement, ReactNode } from "react";
import { useOutletContext } from "react-router";

interface Item {
  name: ReactNode;
  value: ReactNode;
  button?: ReactNode;
  category?: string;
  key?: string;
  onClick: (args: any) => void;
}

interface IProps {
  title: ReactNode;
  items: Item[];
}

export default function DetailsSection({ title, items = [] }: IProps) {
  const outletContxt = useOutletContext() as any;
  const { whiteLabelStyle } = outletContxt ?? {};
  return items?.length > 0 ? (
    <div className="mb-6">
      <div className="">
        {title ? (
          <h3
            className={classNames(
              "text-sm text-black font-medium w-max border-b-2  py-2 pr-2",
              whiteLabelStyle?.theme?.color?.border || "border-indigo-500"
            )}
          >
            {title}
          </h3>
        ) : null}
      </div>
      <div className="py-4">
        {items.map((item, index) => {
          return (
            <div
              className="flex items-center justify-between py-4 border-b border-gray-200"
              key={index}
            >
              <div className="w-4/12 text-xs block font-medium text-gray-500">
                {item.name}
              </div>
              <div className="w-6/12 text-xs">{item.value}</div>
              <div className="w-2/12">{item.button || null}</div>
            </div>
          );
        })}
      </div>
    </div>
  ) : null;
}
